<section class="bk-panel sum" aria-labelledby="sb-sum-title">
  <p class="bk-eyebrow" id="sb-sum-title">This broadcast</p>

  @if (!store.hasRows() && !store.subjectSig() && !store.bodySig()) {
    <p class="sum__empty">
      Upload a sheet to start. Its columns become fields you can merge into the message.
    </p>
  } @else {
    <dl class="sum__list">
      <div class="sum__row">
        <dt>Sheet</dt>
        <dd>
          @if (store.fileNameSig()) {
            <span class="sum__main" [attr.title]="store.fileNameSig()">{{ store.fileNameSig() }}</span>
            <span class="sum__quiet">
              {{ formatCount(store.rowsSig().length) }} {{ plural(store.rowsSig().length, "row", "rows") }}
              @if (store.sheetNames().length > 1 && store.sheetName()) {
                in “{{ store.sheetName() }}”
              }
            </span>
          } @else {
            <span class="sum__unset">Not uploaded</span>
          }
          @if (canEdit(0)) {
            <button type="button" class="sum__edit" aria-label="Change the sheet" (click)="edit.emit(0)">Change</button>
          }
        </dd>
      </div>

      <div class="sum__row">
        <dt>Recipients</dt>
        <dd>
          @if (store.phoneIndex() >= 0) {
            <span class="sum__quiet">Numbers from “{{ store.phoneLabel() }}”</span>
            <span class="sum__lines">
              <app-status
                [text]="formatCount(stats().send) + ' get a message'"
                [status]="stats().send ? 'sent' : 'disabled'"
              />
              @if (stats().invalid) {
                <app-status
                  [text]="formatCount(stats().invalid) + ' invalid, ' + (store.dropInvalid() ? 'left out' : 'sent anyway')"
                  status="failed"
                />
              }
              @if (stats().repeats) {
                <app-status
                  [text]="formatCount(stats().repeats) + ' repeated, ' + (store.dedupe() ? 'left out' : 'sent again')"
                  status="disabled"
                />
              }
              @if (stats().empty) {
                <app-status [text]="formatCount(stats().empty) + ' without a number'" status="disabled" />
              }
            </span>
          } @else {
            <span class="sum__unset">No phone column yet</span>
          }
          @if (canEdit(1)) {
            <button type="button" class="sum__edit" aria-label="Change the phone column" (click)="edit.emit(1)">
              Change
            </button>
          }
        </dd>
      </div>

      <div class="sum__row">
        <dt>From</dt>
        <dd>
          @if (store.senderIdSig()) {
            <span class="sum__main">{{ store.senderIdSig() }}</span>
          } @else {
            <span class="sum__unset">No sender ID yet</span>
          }
          @if (canEdit(2)) {
            <button type="button" class="sum__edit" aria-label="Change the sender ID" (click)="edit.emit(2)">
              Change
            </button>
          }
        </dd>
      </div>

      <div class="sum__row">
        <dt>Name</dt>
        <dd>
          @if (store.subjectSig().trim()) {
            <span class="sum__main">{{ store.subjectSig() }}</span>
          } @else {
            <span class="sum__unset">Not named yet</span>
          }
          @if (canEdit(2)) {
            <button type="button" class="sum__edit" aria-label="Change the name" (click)="edit.emit(2)">Change</button>
          }
        </dd>
      </div>

      <div class="sum__row">
        <dt>Cost</dt>
        <dd>
          @if (totals().messages) {
            <span class="sum__figure" [class.is-settling]="store.settling()">
              {{ formatCount(totals().parts) }} SMS {{ plural(totals().parts, "part", "parts") }}
            </span>
            <span class="sum__quiet">{{ perMessage() }}</span>
          } @else {
            <span class="sum__unset">Shows once the message is written</span>
          }
        </dd>
      </div>
    </dl>
  }
</section>
